<mat-card>
    <mat-card-header>
        <mat-card-title>
            {{ 'Notes' }}
            <mat-card-subtitle *ngIf="isSubmissionNote">
                {{ '(not visible to owners, unless they have read permission for this form)' }}
            </mat-card-subtitle>
            <mat-card-subtitle *ngIf="!isSubmissionNote">{{ '(not visible to owners)' }}</mat-card-subtitle>
        </mat-card-title>
        <button mat-flat-button linkButton disableRipple
                [disabled]="loadingInitialData"
                (click)="addNote()">
            {{ 'Add Note' }}
        </button>
    </mat-card-header>

    <mat-progress-bar mode="query" color="primary" [class.active]="!addNoteEnabled && formGroup.get('id').value">
    </mat-progress-bar>

    <mat-divider></mat-divider>

    <mat-card-content>
        <mat-list [loadingList]="!notes" [loadingLines]="2" [width]="'90%'">
            <app-empty-state *ngIf="!loadingInitialData && notes?.length === 0 && !addNoteEnabled" align="left">
                <span emptyStateText>{{ 'No notes so far' }}</span>
            </app-empty-state>

            <ng-container *ngFor="let note of notes">
                <mat-list-item [class.deleting]="!addNoteEnabled && formGroup.get('id').value === note.id">
                    <span [innerHTML]="note.note"matListItemLine></span>
                    <button [matMenuTriggerFor]="notesMenu"
                            [disabled]="!addNoteEnabled && formGroup.get('id').value === note.id"
                            mat-icon-button linkButton disableRipple matListItemMeta>
                        <mat-icon [svgIcon]="'v2:fi-br-menu-dots'"></mat-icon>
                    </button>
                    <mat-menu #notesMenu="matMenu" xPosition="before" class="v2-panel" [overlapTrigger]="false">
                        <button mat-menu-item (click)="editNote(note.id)">{{ 'Edit Note' }}</button>
                        <button mat-menu-item (click)="deleteNote(note.id)">{{ 'Delete Note' }}</button>
                    </mat-menu>
                </mat-list-item>
                <mat-list-item [class.deleting]="!addNoteEnabled && formGroup.get('id').value === note.id" authorLine>
                    <span [innerHTML]="note.authorName + ' • ' + (note.createdAt | legfiDate: 'MM/DD/YYYY h:mm a')"
                          matListItemLine>
                    </span>
                    <span [innerHTML]="getNoteDetails(note)"  matListItemLine></span>
                </mat-list-item>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-list>
    </mat-card-content>

    <section [formGroup]="formGroup" #editorContainer>
        <ng-container *ngIf="addNoteEnabled">
            <div class="form-group">
                <mat-checkbox formControlName="private" disableRipple [disabled]="hasSelectedRecipients">{{ 'Make private to me' }}
                    <mat-icon matTooltip="{{ hasSelectedRecipients ? 'Disabled since there are email recipients.' : 'Mark note as private and not visible to admins.' }}"
                              [svgIcon]="'v2:fi-br-info'">
                    </mat-icon>
                </mat-checkbox>
            </div>

            <div class="form-group">
                <app-rich-text-editor type="compact"
                                      [useNewStyles]="true"
                                      [isLoading]="false"
                                      [formGroup]="formGroup"
                                      [controlName]="'note'">
                    <mat-progress-bar mode="query" color="primary" [class.active]="!loadingInitialData && (isSaving || refreshingData)">
                    </mat-progress-bar>
                </app-rich-text-editor>
            </div>

            <mat-card-actions [align]="'end'">
                <button mat-flat-button disableRipple color="accent" (click)="cancelEdit()">
                    {{ 'Cancel' }}
                </button>

                <flex-spacer></flex-spacer>

                <ng-container *ngIf="isViolationOrSubmissionNote">
                    <mat-slide-toggle formControlName="sendNotification" color="primary" disableRipple>
                        <span [innerHTML]="'Send notification' + (hasSelectedRecipients ? ' to' : '')"></span>
                        <button *ngIf="hasSelectedRecipients" linkButton preventClick
                                [innerHTML]="formGroup.get('recipients').value.length | i18nPlural: recipientsMapping"
                                (click)="showNotificationMemberSelector()">
                        </button>
                    </mat-slide-toggle>

                    <button-spacer></button-spacer>
                </ng-container>

                <button mat-flat-button disableRipple color="primary"
                        [disabled]="isSaving || !formGroup.get('note').value"
                        (click)="publishNote(formGroup.get('id').value)">
                    {{ formGroup.get('id').value ? 'Update' : 'Publish' }}
                </button>
            </mat-card-actions>
        </ng-container>
    </section>
</mat-card>
